import React, { useState, useEffect } from 'react';

import Autosuggest from 'react-autosuggest';
import { usePaginatedTeams } from '../TeamSelection/usePaginatedTeams';

const formatDivision = team =>
  team.conference ? team.conference.division.name : '';
const formatConference = team => (team.conference ? team.conference.name : '');

const renderSuggestion = suggestion => {
  return (
    <div className="team-suggestion">
      <div className="team-suggestion__image">
        <img src={suggestion.image} alt={suggestion.name} />
      </div>
      <div className="team-suggestion__text">
        <div className="title">
          {suggestion.preferred && <span className="preferred">&#9733;</span>}
          {suggestion.name}
        </div>
        <div className="subtitle">
          {formatDivision(suggestion)} &middot; {formatConference(suggestion)}
        </div>
      </div>
    </div>
  );
};

const AutoTeamSelector = ({ team, setTeam, season, league }) => {
  const [name, setName] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const pageSize = 10;

  const { teams, teamsCount } = usePaginatedTeams(
    league,
    season,
    name,
    0, // first page
    pageSize,
  );

  const inputValue = () => {
    if (team) {
      return team.name;
    }
    return name;
  };

  const inputProps = {
    placeholder: 'Filter by team...',
    value: inputValue(),
    onChange: (event, { newValue }) => {
      setName(newValue);
    },
  };

  useEffect(() => {
    if (teams && teams.length) {
      setSuggestions(teams);
    } else {
      setSuggestions([]);
    }
  }, [teams]);

  const onSuggestionsFetchRequested = ({ value }) => {
    setName(value);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
    setName('');
  };

  const clearSearch = event => {
    setName('');
    setTeam(null);
  };

  const renderInputComponent = inputProps => (
    <div className="clear-search">
      <input {...inputProps} />
      {inputValue() && (
        <span onClick={clearSearch} className="clear-search__btn">
          &#10006;
        </span>
      )}
    </div>
  );

  const renderSuggestionsContainer = ({ containerProps, children, query }) => {
    return (
      <div {...containerProps}>
        {children && children.props.items.length === pageSize && (
          <div className="muted">
            Showing {children.props.items.length} of {teamsCount} Matches
          </div>
        )}
        {children}
      </div>
    );
  };

  const getSuggestionValue = suggestion => suggestion && suggestion.name;

  const onSuggestionSelected = (event, { suggestion }) => {
    setTeam(suggestion);
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      onSuggestionSelected={onSuggestionSelected}
      getSuggestionValue={getSuggestionValue}
      renderInputComponent={renderInputComponent}
      renderSuggestion={renderSuggestion}
      renderSuggestionsContainer={renderSuggestionsContainer}
      inputProps={inputProps}
    />
  );
};

export default AutoTeamSelector;
